module.exports = {
  app: {
    allapp: "All applications",
    ok: "Ok",
    entrust: " Add entrust",
    BackTolist: "Back to list",
    mailbox: "email",
    phone: "phone",
    modify: "modify",
    saveok:
      "Save classification successfully, do you want to return to the application list?",
    deleteok: "Are you sure you want to delete?",
    SendCode: "Send",
    SendAgain: "Send again",
    reSendCode: "Resend",
    applicant: "applicant",
    TaskName: "Task name",
    ApprovalType: "Approval type",
    state: "state",
    operation: "operation",
    details: "details",
    FormFilling: "Form filling",
    cancel: "cancel",
    classificationName: "Please fill in the classification name！",
    ClassificationAlreadyExists: "Classification already exists",
    categories: "No more than 10 categories",
    PermissionSelection: "jurisdiction",
    reason: "reason",
    Submit: "Submit",
    PleaseSelect: "Please select",
  },

  describe: {
    login: "Sign in",
    inputPwd: "Please enter the user password",
    tenant:"Please enter tenant ID",
    inputUser: "Enter one user name",
    inputLdap: "Enter one user name",
    auth: "Authentication center",
    required: "Mandatory Field",
    phoneNumber: "Please enter your mobile phone number",
    phoneVerificationCode: "verification code",
    GraphicVerificationCode: "verification code",
    AppManage: "App Manage",
    SwitchTo: "Switch to",
    ioaQuickLogon: "IOA Quick Logon",
    AccountPasswordLogin: "Account Password Login",
    EnterpriseWechat: "Enterprise Wechat 2.4",
    Use: "Use",
    AboveVersionScanQRcodeLogin: "Above Version Scan QR code Login",
    Or: "or",
    IncorrectFormatOfMobilePhoneNumber:
      "Incorrect format of mobile phone number！",
    PleaseInputTheGraphicVerificationCode:
      "Please input the graphic verification code！",
    ItHasToBeANumber: "It has to be a number",
    PleaseEnterAValidIDNumber: "Please enter a valid ID number.",
    EmailOrInChineseEnglishNumbersUnderscoresAndHorizontalLines:
      "Email or in Chinese, English, numbers, underscores and horizontal lines!",
    TheTwoPasswordsAreInconsistent: "The two passwords are inconsistent",
    ItHasToBe: "It has to be",
    digit: "digit",
    IsAnUnsupportedFormValidationType: "Is an unsupported form validation type",
    RegularVerificationFailed: "Regular verification failed",
    InputCannotExceed: "Input cannot exceed",
    character: "character",
    InputCannotBeLessThan: "Input cannot be less than",
    PleaseCheck: "Please check",
    LongTermValidity: "Long term validity",
    TakeEffectAfter: "Take effect after",
    Invalid: "Invalid",
    PostFailure: "Post failure",
    Disabled: "Disabled",
    NoCertification: "No certification",
    LastCertification: "Last certification",
    Password: "Password",
    QRCode: "QR code",
    fingerprint: "fingerprint",
    DynamicCode: "Dynamic Code",
    ShortMessage: "Short Message",
    Mail: "Mail",
    AbnormalError: "Abnormal error",
    VerificationCodeIsRequired: "Verification code is required",
  },

  error: {
    phoneNumber: "Wrong cell phone number",
  },

  password: {
    forgetpwd: "Forget password?",
  },

  login: {
    other: "Login in other ways",
  },

  menu: {
    ApplicationList: "Application List",
    IDHousekeeper: "ID Keeper",
    jurisdiction: "Authorization",
    Jission: "My Task",
    SwitchUsers:'Switch Users',
    User: "User Information",
    password: "Change Password",
    out: "log out",
  },

  ID: {
    butler: "Binding ID keeper",
    OPEN: "Please open ID keeper",
    Scan: "Scan QR code for binding",
    Download: "ID keeper Download",
  },

  ChangePassword: {
    password: "Change Password",
    Original: "Original password",
    Original1: "Please enter the original password",
    NewPassword: "New password",
    NewPassword1: "Please enter a new password",
    confirm: "Confirm password change",
    Reconfirm: "Confirm new password",
    Reconfirm1: "Please enter the new password again",
    reset: "reset password",
    reset1: "Confirm reset password",
    Forget: "Forget password - reset password",
    phone: "Phone Number",
    ErrorMsg: "Wrong cell phone number",
    phone1: "Please enter your mobile phone number",
    Dynamic: "Dynamic code",
    Dynamic1: "Please input dynamic code！",
    ResetValidation: "Reset validation",
    ReturnToLogin: "Sign in",
    return: "return",
    SetMobileNumber: "Set mobile number",
    VerificationCode: "Verification code",
    VerificationCode1: "Please enter the verification code",
    MailReset: "Mail reset",
    MailBox: "Mailbox",
    MailBox1: "Please input email",
    ReturnToSelectResetMode: "Return to select reset mode",
    Next: "next step",
    register: "Register",
  },

  user: {
    information: "User information",
    lastTime: "Last visit time",
    name: "user name",
    mail: "mailbox",
    effective: "take effect",
    attribute: "user attribute",
    Return: "Back to list",
  },

  Authorization: {
    apply: "New application",
    AuthorityDefinition: "Authority definition",
    state: "state",
    errorMessage: "error message",
    operation: "operation",
    cancel: "cancel",
  },

  AppManage: {
    add: "Add application category",
    addApp: "Add app",
    sequencing: "Application sequencing",
    addTo: "Add To",
    Del: "Delete",
    return: "<return",
    save: "save",
    name: " Classification name",
  },

  ApplicationSettings: {
    jurisdiction: "jurisdiction：",
    state: "status：",
    available: "available",
    Disable: "Disable",
    AccountStatus: "Account status：",
    AccountPeriod: "Account period",
    AddDelegation: "Add delegation",
    DelegationList: "Delegation list",
    NumberOfAccounts: "Number of accounts：",
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/utiles/locale/en_US.js
// module id = 259
// module chunks = 0